<template>
    <nav class="bg-zinc-800 text-zinc-100 px-4 py-3 flex justify-between items-center lg:shadow-xl">
        <Link :href="route('home')" class="flex items-center ml-0 lg:ml-4">
        <img src="../../../../public/Logo_Hydros_c.png" alt="Logo" class="w-auto h-[33px] lg:h-[38px]" loading="lazy">
        </Link>
        <ul class="flex items-center">
            <li class="lg:mr-0">
                <a href="https://map.sinaubumi.org/" target="_blank"
                    class="hidden lg:inline-block text-sm lg:text-base font-medium text-white hover:text-zinc-300 mr-4">
                    AWS
                </a>
                <a href="https://awqm.sinaubumi.org/" target="_blank"
                    class="hidden lg:inline-block text-sm lg:text-base font-medium text-white hover:text-zinc-300 mr-4">
                    AWQM
                </a>
                <a href="https://fwi.sinaubumi.org/" target="_blank"
                    class="hidden lg:inline-block text-sm lg:text-base font-medium text-white hover:text-zinc-300 mr-4">
                    FWI
                </a>
                <a href="https://hpt.sinaubumi.org/" target="_blank"
                    class="hidden lg:inline-block text-sm lg:text-base font-medium text-white hover:text-zinc-300 mr-4">
                    HPT
                </a>
                <button id="toggleAbout">
                    <p class="hidden lg:inline-block text-sm lg:text-base font-medium text-white hover:text-zinc-300">
                        Credits
                    </p>
                </button>
            </li>
            <li class="lg:hidden">
                <button id="toggleAbouts">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                        class="h-6 fill-zinc-100 inline-block">
                        <path
                            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                    </svg>
                </button>
            </li>
        </ul>
    </nav>
</template>

<script>
import { Link } from "@inertiajs/vue3";

export default {
    components: {
        Link,
    },
};
</script>